import { handleActions } from 'redux-actions';

import { actions } from '../actions/attachmentsPreviewModal';

const { attachmentsPreviewModalOpen, attachmentsPreviewModalClose } = actions;

export type AttachmentsPreviewModalState = {
  fileName: string | null;
  url: string | null;
};

export const initialState: AttachmentsPreviewModalState = {
  fileName: null,
  url: null,
};

const reducer = handleActions<AttachmentsPreviewModalState, any>(
  {
    [attachmentsPreviewModalOpen.toString()]: (
      state: AttachmentsPreviewModalState,
      action,
    ) => {
      const { fileName, url } = action.payload;

      return {
        ...state,
        url,
        fileName,
      };
    },

    [attachmentsPreviewModalClose.toString()]: (
      state: AttachmentsPreviewModalState,
      action,
    ) => {
      return initialState;
    },
  },
  initialState,
);

export default reducer;
